// extracted by mini-css-extract-plugin
export default {"card":"card--sJg09","section-title":"section-title--OJ7RY","overview-item-wrap":"overview-item-wrap--_EEVn"};